'use client';
import { useWindowScroll } from '@mantine/hooks';
import { ChevronsDown } from 'lucide-react';
import { trackEvent } from '@/utils/umami';
import { cn } from '@/utils/utils';

const ScrollDownBtn = () => {
    const [scroll, scrollTo] = useWindowScroll();
    return (
        <ChevronsDown
            size={35}
            color='#878EA1'
            onClick={() => {
                trackEvent('scroll-down');
                scrollTo({ y: window.innerHeight });
            }}
            className={cn('cursor-pointer hover:animate-bounce', scroll.y > 20 && 'animate-bounce')}
        />
    );
};

export default ScrollDownBtn;
